<template>
  <div class="account">
    <global-header :nowChose="'mystudy'"></global-header>
    <router-view></router-view>
    <foot-nav></foot-nav>
  </div>
</template>

<script type="text/ecmascript-6">
  import footNav from 'components/footnav/FootNav'
  import {saveLocal, loadLocal} from 'common/js/store.js';
//  import globalNav from 'components/globalnav/GlobalNav'
  import globalHeader from 'components/globalheader/GlobalHeader'
  export default{
    data(){
      return {
        id: (() => loadLocal('id', false))(),
        userinfo: (() => loadLocal('userinfo', false))(),
      }
    },
    created(){
    },
    components: {
      globalHeader,
      footNav
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .account
    padding-top: 124px
    position: relative
    background #f2f2f2
</style>



// WEBPACK FOOTER //
// src/page/account/Account.vue